import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from "react-table";
import { numberFormat } from "../../../../../../services/helpers";
import { selectDefTableSize } from '../../../../../../selectors/screenSelectors';
import StringInput from '../../../../../common/table/StringInput';
import createSelect from '../../../../../common/table/createSelect';
import DatePicker from '../../../../../common/table/DatePicker';
import NumberInput from '../../../../../common/table/NumberInput';

class Table extends Component {

    constructor(props){
        super(props);
        this.state = {};
    }

    render(){
        return (
            <div className={`table-main-wrap table-main-wrap_register ${this.props.propsGetDataStatus == 'pending' ? 'table-main-wrap_loading' : '' }`}>
                <div className="table-header">Інформація про аудит реєстра</div>
                <ReactTable
                    getTheadFilterThProps={(rowInfo) => {
                        return {
                            style: {
                                overflow: 'visible',
                                textAlign: 'left'
                            }
                        }
                    }}
                    getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.row) {
                            return {
                                onClick: () => {
                                    this.props.propsRowClick({
                                        id: rowInfo.row._original.ID,
                                        index: rowInfo.index
                                    });
                                },
                                style: {
                                    backgroundColor: rowInfo.index === this.props.index ? '#B8B8B8' : 'white',
                                    color: rowInfo.index === this.props.index ? 'white' : 'black',
                                    cursor: 'pointer'
                                }
                            }
                        }else{
                            return {}
                        }
                    }}
                    data={this.props.propsArraySort}
                    columns={[
                        {
                            Filter: StringInput,
                            Header: "Назва компанії",
                            accessor: "Employee.Department.Company.Name",
                            id: "Employee/Department/Company/Name"
                        },
                        {
                            Filter: StringInput,
                            Header: "Назва відділу",
                            id: "Employee/Department/Name",
                            accessor: "Employee.Department.Name"
                        },
                        {
                            Filter: StringInput,
                            Header: "Прізвище",
                            id: "Employee/Surname",
                            accessor: "Employee.Surname"
                        },
                        {
                            Filter: StringInput,
                            Header: "Ім'я",
                            id: "Employee/Name",
                            accessor: "Employee.Name"
                        },
                        {
                            Filter: StringInput,
                            Header: "По-батькові",
                            id: "Employee/Patronymic",
                            accessor: "Employee.Patronymic"
                        },
                        {
                            Filter: StringInput,
                            Header: "Номер телефону",
                            id: "Employee/PhoneNumber",
                            accessor: "Employee.PhoneNumber"
                        },
                        {
                            Filter: createSelect({ options: this.props.data.fuelList, placeholder: 'Виберіть' }),
                            Header: "Тип палива",
                            minWidth: 140,
                            id: "AuditFuel/Barrel/TypeFuelID",
                            accessor: item => {
                                return item.AuditFuel.Barrel.TypeFuel !== null ? item.AuditFuel.Barrel.TypeFuel.FuelName : '-----------'
                            }
                        },
                        {
                            Filter: StringInput,
                            Header: "Номер документу",
                            id: "AuditFuel/DocNumber",
                            accessor: "AuditFuel.DocNumber"
                        },
                        {
                            Filter: DatePicker,
                            minWidth: 160,
                            Header: "Дата операції",
                            id: "AuditFuel/FuelDate",
                            accessor: item => {
                                return new Date(item.AuditFuel.FuelDate).toLocaleString()
                            }
                        },
                        {
                            Filter: NumberInput,
                            minWidth: 130,
                            Header: "Сума, грн",
                            id: "AuditFuel/Amount",
                            className: "rightAlign",
                            accessor: item => {
                                return numberFormat(item.AuditFuel.Amount)
                            }
                        },
                        {
                            Filter: NumberInput,
                            minWidth: 130,
                            Header: "Ціна, грн",
                            id: "AuditFuel/Price",
                            className: "rightAlign",
                            accessor: item => {
                                return numberFormat(item.AuditFuel.Price)
                            }
                        },
                        {
                            Filter: NumberInput,
                            minWidth: 130,
                            Header: "Об'єм",
                            id: "AuditFuel/Capacity",
                            className: "rightAlign",
                            accessor: item => {
                                return numberFormat(item.AuditFuel.Capacity)
                            }
                        }
                    ]}
                    defaultPageSize={this.props.defaultPageSize}
                    className=" -highlight"
                    pageSize={this.props.pageSize}
                    page={this.props.page}
                    onPageSizeChange={this.props.handleChangePageSize}
                    onPageChange={this.props.handleChangePage}
                    manual={true}
                    filterable
                    sortable
                    multiSort
                    onFilteredChange={this.props.handleOnFilterChange}
                    onSortedChange={this.props.handleOnSortChange}
                    filtered={this.props.filtered}
                    sorted={this.props.sorted}
                    pages={Math.ceil(this.props.count / this.props.pageSize)}
                    NoDataComponent={() => null}
                    previousText="Назад"
                    nextText="Вперед"
                    rowsText="рядків"
                    pageText="Сторінка"
                    ofText="з"
                />
                <div className="loading"></div>
            </div>
        )

    }
}

const mapStateToProps = (state) => {
    return {
        defaultPageSize: selectDefTableSize(state),
        typeTerm: typeof state.user.data.typeTermList != "undefined" ? state.user.data.typeTermList: []
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
       dispatch
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Table);
